import { jsx as _jsx } from "react/jsx-runtime";
import MarkdownToJsx from "markdown-to-jsx";
import { stripHtml } from "string-strip-html";
import { styled } from "../theme";
import { IconRenderer } from "./renderers/IconRenderer";
import { LinkRenderer } from "./renderers/LinkRenderer";
import { DateRenderer } from "./renderers/DateRenderer";
import { StateNameRenderer } from "./renderers/StateNameRenderer";
import { ModalRenderer } from "./renderers/ModalRenderer";
import { RedTextRenderer } from "./renderers/RedTextRenderer";
import { parse } from "./template";
const TEMPLATE_PARSER_OPTS = {
    regex: /\[{2}(.+?)\]{2}/g,
    skipUndefined: true,
    throwOnUndefined: false,
};
export const interpolate = (values = {}) => (source, defaultValue = "") => parse(source, values, TEMPLATE_PARSER_OPTS, defaultValue);
export const Markdown = ({ staticContent, values = {}, source, transformUrl, }) => {
    const overrides = {
        pre: StyledPre,
        code: StyledCode,
        a: (props) => _jsx("span", { children: props.children }),
        "res:icon": (props) => _jsx(IconRenderer, { ...props }),
        "res:date": (props) => _jsx(DateRenderer, { ...props, values: values }),
        "res:link": (props) => (_jsx(LinkRenderer, { ...props, values: values, transformUrl: transformUrl })),
        "res:state": (props) => (_jsx(StateNameRenderer, { ...props, values: values })),
        "res:modal": (props) => (_jsx(ModalRenderer, { ...props, staticContent: staticContent })),
        del: (props) => _jsx("u", { children: props.children }),
        red: (props) => _jsx(RedTextRenderer, { ...props }),
    };
    return (_jsx(MarkdownToJsx, { options: { overrides }, children: stripHtml(interpolate(values)(source), {
            ignoreTags: ["res", "a", "title", "TITLE", "Title", "small", "red"],
        }).result }));
};
const StyledPre = styled.pre `
  border-radius: 6px;
  padding: 8px;
  background: ${({ theme }) => theme.color.darkBlue5};
  border: 1px solid ${({ theme }) => theme.color.darkBlue10};

  code {
    border: initial;
    padding: initial;
    border-radius: initial;
    background: transparent;
  }
`;
const StyledCode = styled.code `
  border-radius: 6px;
  padding: 8px;
  background: ${({ theme }) => theme.color.darkBlue5};
  border: 1px solid ${({ theme }) => theme.color.darkBlue10};
`;
